'use strict';

import { Base64 } from 'js-base64';

export function decodeJSONFromBase64(encoded) {
  try {
    return JSON.parse(Base64.decode(encoded));
  } catch(e) {
    console.warn('Data to decode was invalid:', e);
  }
}


// WEBPACK FOOTER //
// ./src/common/decoder.js